export default __webpack_public_path__ + "static/media/ROM SYLLABUS_2026-27 CLASS 8.db932f0e.pdf";